import React from 'react';
import { Form, Formik } from 'formik';
import { ISigningAppointmentEditFormData } from 'types/signingAppointment/ISigningAppointmentEditFormData';
import { AddContactForm } from '../../CreateSigningAppointment/shared/AddContactForm';
import { FolderArrowDownIcon } from '@heroicons/react/24/outline';
import { BodyTextTW } from 'tailwindComponents/bodyText/BodyTextTW';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { INotaryDetailsData } from '../../../../../types/signingAppointment/INotaryDetailsData';
import { attorneyOrNotary } from '../../../../../utilities/order/scheduling/attorneyOrNotary';
import { useSelectAppointmentFromPathParam } from '../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import {
  notaryDigSyncValidationSchema,
  notaryValidationSchema,
} from '../../CreateSigningAppointment/03_methodsStep/notaryStep/notaryForm/NotaryForm';
import { sanitizeNotary } from './util';

export interface IEditNotaryFormProps {
  signingAppointmentId: string;
  notary?: INotaryDetailsData;
  onSave: (formData: ISigningAppointmentEditFormData) => Promise<void>;
  title: string;
  onClose: () => void;
}

export const EditNotaryForm: React.FC<IEditNotaryFormProps> = ({
  signingAppointmentId,
  notary,
  onSave,
  title,
  onClose,
}) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  const isDss = appointmentFromPath?.isDigitalScheduling;
  return (
    <Formik
      initialValues={{
        id: signingAppointmentId,
        notary: notary,
      }}
      validationSchema={isDss ? notaryDigSyncValidationSchema : notaryValidationSchema}
      onSubmit={async (values: ISigningAppointmentEditFormData) => {
        if (values.notary) {
          const sanitizedNotary = sanitizeNotary(values?.notary);

          await onSave({
            ...values,
            notary: sanitizedNotary,
          });
          onClose();
        }
      }}
      enableReinitialize
    >
      {({ values, isValid, dirty }) => (
        <Form>
          <AddContactForm
            isSigner={false}
            title={title}
            notary={values.notary}
            hideTrashIcon
            onTrashIconClick={onClose}
            columnsClassName="grid-cols-2"
            emailRequired={false}
            isLegacy={!isDss}
          />

          <div className={'flex justify-items-center pt-3'}>
            <ButtonTW secondary type={'submit'} disabled={!isValid || !dirty}>
              <div className={'flex justify-start'}>
                <FolderArrowDownIcon className={'mr-1 h-5 w-5'} />
                <BodyTextTW>Save {attorneyOrNotary(appointmentFromPath?.signingMethod)}</BodyTextTW>
              </div>
            </ButtonTW>

            <ButtonTW className={'ml-2'} secondary={true} ghost={true} onClick={onClose}>
              Cancel
            </ButtonTW>
          </div>
        </Form>
      )}
    </Formik>
  );
};
